module.exports = __webpack_public_path__ + "logo_swg.jpg?edcb62efbbf5868555f94ea39562b8b5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_swg.jpg
// module id = 381
// module chunks = 0